import { PipesModule } from 'src/app/_pipes/pipes.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OrderViewComponent } from './order-view.component';

@NgModule({

  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    RouterModule,
    PipesModule
  ],

  declarations: [OrderViewComponent],
  exports: [OrderViewComponent]


})
export class OrderViewModule { }
